// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3-own","col":"styles_col__2zoED","fulfillmentStatus":"styles_fulfillmentStatus__2KUzN","emailCol":"styles_emailCol__-9yF8"};